module.exports = __webpack_public_path__ + "static/media/documents_icon_wh.a4c17bce.svg";